/* eslint-disable no-undef */

import React, { useContext, useEffect, useState, Suspense } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-use'

import { GetCategories, GetVenuesWithInRange, SearchVenuesWithProducts } from '@kolayyolla/common/store/actions'

import { SortBy } from '@kolayyolla/common/utils/enums'

import {  defaultPaymentTypes } from '@kolayyolla/common/utils/globalVars'

import { useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'

import Footer from '../../components/Footer'
import Topbar from '../../components/Topbar'
import ThemeContext from '../../ThemeContext'

import CategoriesComponent from './CategoriesComponent'
import LandingPage from './LandingPage'
import LocationsMap from './LocationsMap'
import VenuesList from './VenuesList'

const useStyles = makeStyles((theme) => {
  const classList = {
    container: {
      maxWidth: 1120,
      minWidth: 350,
      minHeight: 'calc(100vh - 50px)',
      margin: 'auto',
      fontFamily: theme.typography.fontFamily,
      paddingBottom: 285,
      transition: 'all 1s ease 0s',
      '& > h5': {
        fontSize: '1.3rem',
        backgroundColor: '#f1f1f1',
        boxShadow: 'inset 0px 0px 5px 0px rgba(50,50,50,0.25)',
        padding: 4
      }
    },
    settingsContainer: {
      minWidth: 350,
      margin: '1rem auto auto',
      right: 0,
      left: 0,
      display: 'grid',
      gridTemplateRows: 'min-content 1fr min-content',
      gap: theme.spacing(2)
    },
    title: {
      marginTop: theme.spacing(1),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      height: 30,

      '& h5': {
        maxWidth: 1120,
        position: 'absolute',
        width: '100%',
        textAlign: 'center'
      }
    }
  }
  return classList
})

const Home = () => {
  const classes       = useStyles()
  const dispatch      = useDispatch()
  const location      = useLocation()
  const isSmallScreen = useMediaQuery((t) => t.breakpoints.down('sm'))
  const query         = new URLSearchParams(location.search)
  const q             = query.get('q')

  const auth          = useSelector((state) => state.auth)
  const user          = useSelector((state) => state.user)
  const venues        = useSelector((state) => state.venues.data)
  const searchresults = useSelector((state) => state.searchresults.data)

  const category = query.get('category')
  const online   = query.get('online')
  const loyalty  = query.get('loyalty')
  const table    = query.get('table')
  const mintotal = query.get('mintotal')
  const minrate  = query.get('minrate')
  const payment  = query.get('payment')
  const sort     = query.get('sort')

  const [list, setList] = useState(venues)

  const [userLocation, setUserLocation] = useState(null)
  const { resetTheme }                  = useContext(ThemeContext)

  useEffect(() => {
    dispatch(GetCategories())
    resetTheme()
  }, [])

  useEffect(() => {
    let newList = q ? [...searchresults] :  [...venues]

    if (category) newList = newList.filter((v) => v.categories.includes(category))

    if (online) newList = newList.filter((v) => v.canOrder)

    if (loyalty) newList = newList.filter((v) => v?.loyalty?.settings?.isActive)

    if (table) newList = newList.filter((v) => v?.loyalty?.settings?.inShopActive)

    if (mintotal && mintotal >= 0 && mintotal < 50) newList = newList.filter((v) => v.minTotal <= mintotal)

    if (minrate && minrate > 10) newList = newList.filter((v) => v?.loyalty?.settings?.minimumRate >= minrate)

    if (payment !== 'any' && defaultPaymentTypes.findIndex((dpt) => dpt.key === payment) !== -1) {
      newList = newList.filter((v) => {
        return v.paymentTypes.filter((pt) => pt.isActive).map((pt) => pt.key).includes(payment)
      })
    }

    // Start sorting
    const splitArr = newList.reduce((acc, cur) => {
      if (cur.canOrder) acc[0].push(cur)
      else acc[1].push(cur)
      return acc
    }, [[], []])

    if (sort) {
      if (sort === SortBy.NAME) setList([...splitArr[0].sort((a, b) => a.name.localeCompare(b.name)), ...splitArr[1]])
      else if (sort === SortBy.MIN_TOTAL) setList([...splitArr[0].sort((a, b) => (a.minTotal - b.minTotal)), ...splitArr[1]])
    } else setList([...splitArr[0].sort((a, b) => (a.distance - b.distance)), ...splitArr[1]])
  }, [venues, category, online, loyalty, table, mintotal, minrate, payment, sort, q, searchresults])

  useEffect(() => {
    const getUserLocation = () => {
      if (user.data._id) {
        if (user.data.addresses.length > 0) {
          return user.data.addresses.find((a) => a._id === user.data.defaultAddress)
        }
      } else {
        return JSON.parse(localStorage.getItem('mylocation'))
      }
      return null
    }

    setUserLocation(getUserLocation())
  }, [user.data._id, user.data.addresses, user.data.defaultAddress])

  useEffect(() => {
    if (userLocation?.h3Index) {
      if (q) {
        dispatch(SearchVenuesWithProducts({
          h3Index: userLocation.h3Index,
          q
        }))
      } else {
        dispatch(GetVenuesWithInRange({
          h3Index: userLocation.h3Index,
          q
        }))
      }
    }
  }, [userLocation?.h3Index, q])

  if (auth.isLoggedIn && !userLocation && !user.isLoaded) {
    return null
  }

  if (userLocation && location.hash !== '#wl') {
    return (
      <div style={{ position: 'relative' }}>
        <Suspense fallback={<div />}>
          <Topbar position="sticky" />

          {
              location.hash !== '#map' || isSmallScreen
                ? (
                <div className={classes.container}>
                  <CategoriesComponent />
                  <VenuesList list={list} />
                </div>
                  )
                : userLocation.coord ? <LocationsMap point={{ name: userLocation.name, coord: userLocation.coord }}  venues={list} /> : <div>Yükleniyor...</div>

            }

          <Footer />
        </Suspense>

      </div>
    )
  }
  return <Suspense fallback={<div />}><LandingPage /></Suspense>
}

export default Home
